import styled from 'styled-components';
import { fontPrices} from '../../theme/theme'

type colorBadge = {
    color: string,
    isSelected?: boolean,
    isFooter?: boolean,

}


export const BadgeContainer = styled.div<colorBadge>`
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center !important;
    border-radius: 50%;
    top: -11px;
    right: -11px;
    background: white;
    border-radius: 50%;
    border: 2px solid ${props => props.color};
    width: 45%;
    height: 45%;
    font-family: ${fontPrices};
    font-size: 12px;
    font-weight: 700;

    @media (max-width: ${props => props.theme.breakpoints.md}){
            width: 1.1rem;
            height: 1.1rem;
            top: -3.5px;
            right: ${props => props.isFooter ? '3rem' : '-6.5px;'};
            color: white;
            border: none;
            font-size: 8px;
            align-items: flex-end;
            background: ${props => props.isSelected ? props.color : 'rgba(140, 140, 145, 1)'};
            

        };


`